import { CellContext } from "@tanstack/react-table";
import { pluralizeWithCount } from "@common/helpers/string";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { CountButtonCell } from "@components/items/Cells/CountButtonCell";
import type { OrganizationTaskTemplateRow } from "../organizationTaskTemplatesViewConfig";
import { getOrganizationTaskTemplatesTableMeta } from "../organizationTaskTemplatesTableMeta";

export const OrganizationTaskTemplateServiceTemplatesCell = memo(
    function OrganizationTaskTemplateServiceTemplatesCell({
        row,
        table,
    }: CellContext<ViewTableFeatures, OrganizationTaskTemplateRow, string>) {
        const meta = getOrganizationTaskTemplatesTableMeta(table);
        const templateId = row.original.id;
        const count = meta?.serviceTemplateCounts[templateId] ?? 0;

        return (
            <CountButtonCell
                count={count}
                ariaLabel={`View ${pluralizeWithCount("service template", count)} using ${row.original.name}`}
                onClick={() =>
                    meta?.callbacks?.onViewServiceTemplates(templateId)
                }
            />
        );
    },
);
